"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostPaymentNotifyFromPayU = void 0;
const Base_1 = require("./Base");
exports.PostPaymentNotifyFromPayU = {
    url: Base_1.URL_BASE + "/notifyFromPayU",
    method: "POST",
    secure: false
};
//# sourceMappingURL=PostNotifyFromPayU.js.map